/**
 * Created by adalto on 4/4/14.
 */

import { actionCreators } from 'react/api/actions/monitor';

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Monet.Session.ConfigInfoTruckMarker = Monet.Session.ConfigInfoTruckMarker || {};

Greenmile.Toolbar.Map.ConfigInfoTruckMarker = function (selector) {

    Monet.Session.ConfigInfoTruckMarker.timeout = Monet.Session.ConfigInfoTruckMarker.timeout || 0;

    var cancelTimeoutToHideListOrganization = function () {
        clearTimeout(Monet.Session.ConfigInfoTruckMarker.timeout);
    };

    var getOptionsByOrganizationId = function (organizationId) {

        var divSelect = document.createElement('div');
        var select = document.createElement('select');
        var action = new Greenmile.Toolbar.ConfigInfoMarkerTruckActions();
        var options = Greenmile.ConfigInfoMarkerTruck.Utils.options;
        var dataSelected = action.getInfoMarkerSelectedByOrganizationId(organizationId);

        var saveOnLocalStorage = function (el) {

            var indexSelected = el.target.selectedIndex;

            var optionSelected = el.target[indexSelected];

            action.saveOnLocalStorage(organizationId, optionSelected.value);

            if (App.Objects.RouteMonitorRoutes) {
                App.Objects.RouteMonitorRoutes.updateRoutesLabel();
            }

            window.GreenmileReduxStore.dispatch(actionCreators.request());
            window.GreenmileReduxStore.dispatch(actionCreators.updateRoutePanelTitle());
        };

        var callback = function (el) {

            saveOnLocalStorage(el);

            var map = new App.Routers.RouteMonitor();
            map.getEquipmentPositionsByOrganizations();

        };

        for (var i in options) {

            var option = document.createElement('option');
            var value = options[i].value;

            option.value = value;
            option.innerHTML = options[i].content();

            if (value === dataSelected) {
                option.selected = true;
            }

            select.appendChild(option);

        }

        select.removeEventListener('change', callback);
        select.addEventListener('change', callback);

        divSelect.appendChild(select);

        return divSelect;
    };

    var formatContent = function (organizations) {

        var contentFormatted = document.createDocumentFragment(),
            divOnMouseOver   = function () {
                cancelTimeoutToHideListOrganization();
            };

        for (var i = 0; i < organizations.size(); i++) {

            var organization = organizations.at(i);
            var div = document.createElement('div');
            var labelDescription = document.createElement('label');
            var description = organization.get('description');

            labelDescription.title = description;
            labelDescription.innerHTML = description;

            div.appendChild(labelDescription);
            div.appendChild(getOptionsByOrganizationId(organization.get('id')));

            div.addEventListener('mouseover', divOnMouseOver);

            contentFormatted.appendChild(div);

        }

        return contentFormatted;

    };

    this.getAllOrganizations = function (callback) {
        const request = new Monet.Ajax();
        request.url = 'Organization';

        request.success = function (data) {
            if (data) {
                const organizations = new App.Collections.Organizations();
                organizations.add(data);

                if (callback) {
                    callback(organizations);
                }
            }
        };

        request.error = function (xhr) {
            Monet.Configurations.errorNotification(null, xhr);
        };

        request.send();
    };

    this.addListeners = function () {

        var callback = function (data) {

            var divContent = document.querySelector(selector + ' .listOrganization');
            var contentFormatted = formatContent(data);

            var setTimeoutToHideListOrganization = function (e) {

                if (Monet.Session.ConfigInfoTruckMarker.timeout) {
                    cancelTimeoutToHideListOrganization();
                }

                if (e.target.nodeName !== 'SELECT') {

                    Monet.Session.ConfigInfoTruckMarker.timeout = setTimeout(function () {
                        if (divContent.parentNode && divContent.parentNode.className !== 'routeMonitorRightPanelBody') {
                            divContent.parentNode.style.display = 'none';
                        }
                    }, 500);

                }

            };

            var cancelTimeoutAndShowListOrganization = function () {

                if (divContent.parentNode) {
                    divContent.parentNode.style.display = 'block';
                    cancelTimeoutToHideListOrganization();
                }

            };

            if (divContent) {
                divContent.parentNode.removeEventListener('mouseout', setTimeoutToHideListOrganization);
                divContent.parentNode.addEventListener('mouseout', setTimeoutToHideListOrganization);

                divContent.parentNode.removeEventListener('mouseover', cancelTimeoutAndShowListOrganization);
                divContent.parentNode.addEventListener('mouseover', cancelTimeoutAndShowListOrganization);

                divContent.parentNode.parentNode.removeEventListener('mouseout', setTimeoutToHideListOrganization);
                divContent.parentNode.parentNode.addEventListener('mouseout', setTimeoutToHideListOrganization);

                divContent.parentNode.parentNode.removeEventListener('mouseover', cancelTimeoutAndShowListOrganization);
                divContent.parentNode.parentNode.addEventListener('mouseover', cancelTimeoutAndShowListOrganization);

                divContent.appendChild(contentFormatted);
            }

        };

        this.getAllOrganizations(callback);

    };


};
